export var SubscriptionTier;
(function (SubscriptionTier) {
    SubscriptionTier["FREE"] = "free";
    SubscriptionTier["STARTER"] = "starter";
    SubscriptionTier["GROWTH"] = "growth";
    SubscriptionTier["SCALE"] = "scale";
    SubscriptionTier["ENTERPRISE"] = "enterprise";
})(SubscriptionTier || (SubscriptionTier = {}));
//# sourceMappingURL=tenant.js.map